import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { SELECTION_ALL } from '../../common/constants';
import { useTranslation } from 'react-i18next';

const DeviceDropdown = ({ onChange, companyID, deviceID }) => {
  const { t } = useTranslation();
  const devices = useSelector(state => {
    if (companyID !== null && companyID !== "" && companyID !== SELECTION_ALL) {
      // companyID is valid, return devices for that company or [] if not found
       return (state.Admin.device[companyID] || [])
      .slice() // clone to avoid mutating Redux state
      .sort((a, b) => a.id - b.id);
    } else {
      // Otherwise, combine all devices from all companies
      const allDevices = [...Object.values(state.Admin.device).flat()]
        .sort((a, b) => a.id - b.id); // sort by number ascending
      return allDevices;
    }
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // Use null or a special value for "All"
  const [selectedDeviceId, setSelectedDeviceId] = useState(deviceID || SELECTION_ALL);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  // Find the selected company object (if not "all")
  const selectedDevice = devices.find(c => c.id === selectedDeviceId);

  // Handle selection change
  const handleSelect = (id) => {
    setSelectedDeviceId(id);
    if (onChange) {
      onChange(id);
    }
  };

  useEffect(() => {
    setSelectedDeviceId(deviceID || SELECTION_ALL);
  }, [deviceID]);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret color="primary" className="mb-2 me-2 ms-2">
        {selectedDeviceId === SELECTION_ALL
          ? t('PageAdmin.SelectAllDevices')
          : (selectedDevice ? selectedDevice.id : t('PageAdmin.SelectDevice'))}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem
          key={SELECTION_ALL}
          onClick={() => handleSelect(SELECTION_ALL)}
          active={selectedDeviceId === SELECTION_ALL}
        >
          {t('PageAdmin.SelectAllDevices')}
        </DropdownItem>
        {devices.map(device => (
          <DropdownItem
            key={device.id}
            onClick={() => handleSelect(device.id)}
            active={selectedDevice === device.id}
          >
            {device.id}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default DeviceDropdown;
